
import { mapActions } from "vuex";
import { Navigation } from "swiper";

import ShopifyProductTile from "~/components/common/AppShopifyProductTile";
import { delay } from "~/utils";

export default {
  components: { ShopifyProductTile },

  props: {
    products: { type: Array, required: true },
    swiperClass: { type: String, default: "" },
  },

  data: () => ({ swiper: null }),

  computed: {
    swiperOptions() {
      return {
        slidesPerGroup: 2,
        breakpoints: {
          // when window width is >= 767
          767: {
            slidesPerGroup: 4,
          },
        },
        slidesPerView: "auto",
        loopFillGroupWithBlank: false,
        modules: [Navigation],
        navigation: {
          nextEl: `.${this.swiperClass}-next`,
          prevEl: `.${this.swiperClass}-prev`,
        },
      };
    },
  },

  async mounted() {
    await this.$swiper.init(`.swiper.${this.swiperClass}`, this.swiperOptions);
  },

  destroyed() {
    this.$swiper.destroy(`.swiper.${this.swiperClass}`);
  },

  methods: {
    ...mapActions("recommendations", ["trackBeacon"]),
    async handleClick(navType) {
      const source = this.products[0]?.source;
      if (!source?.includes("searchspring-")) {
        return;
      }

      const [, tag] = source.split("searchspring-");
      if (navType === "prev") {
        await this.trackBeaconWithDelay("click", tag, 0);
        return;
      }

      if (navType === "next") {
        await this.trackBeaconWithDelay("clickImpression", tag, 250);
      }
    },
    async trackBeaconWithDelay(type, tag, delayMS) {
      // Add setTimeout so that all products are in visible list for current impression
      try {
        await delay(delayMS);
        await this.trackBeacon({ type, tag });
      } catch (error) {
        this.$bugsnag.notify(error, e => {
          e.context = `ProductCarousel trackBeaconWithDelay ${type}`;
        });
      }
    },
  },
};
